import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import { Link } from "react-router-dom";

import { useTrans } from '~/hooks/useTrans';
import { IQuickCommentItem } from "~/providers/admin-interfaces";
import { getLink } from "~/providers/route";

import "./style.less";

interface IAdminQuickCommentsTable {
	items: Array<IQuickCommentItem>;
	disabled?: boolean;
	onClick?: (item: IQuickCommentItem) => void;
}

export default function AdminQuickCommentsTable({
	items = [],
	disabled = false,
	onClick = () => {},
}: IAdminQuickCommentsTable) {
	const { trans, transQuickCommentType } = useTrans();
	const HEADERS = [
		"adminQuickCommentsTable.value",
		"adminQuickCommentsTable.type",
		"adminQuickCommentsTable.project",
		"",
	];
	const HEADERS_CENTER = [];

	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADERS.map(header => <TableCell sx={{ fontWeight: "bold", ...HEADERS_CENTER.includes(header) ? { textAlign: "center" } : {} }} key={header}>
						{ trans(header) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ items.map(item => (<TableRow key={item.id}>
					<TableCell>
						{ item.value }
					</TableCell>
					<TableCell>
						{ transQuickCommentType(item.type) }
					</TableCell>
					<TableCell>
						<Link to={getLink("project-dashboard", true, { projectId: item.projectId })}>
							{ item.projectTitle }
						</Link>
					</TableCell>
					<TableCell>
						<div className="adminQuickCommentsTable__buttons">
							<Button color="success" variant="contained" onClick={() => onClick(item)} disabled={disabled}>
								{ trans("adminQuickCommentsTable.addComment") }
							</Button>
						</div>
					</TableCell>
				</TableRow>)) }
			</TableBody>
		</Table>
	</TableContainer>;
}
